import * as types from '../types';
const exerciseEntityUpdated = (exerciseId, exerciseEntity) => ({
  exerciseEntity,
  exerciseId,
  type: types.EXERCISE_ENTITY_UPDATED
});
export default exerciseEntityUpdated;